import { ActionTypeEnum } from '@empathybroker/tsclient-play/dist/enums/action-type.enum';

import { AdminFeatureIdEnum } from './feature-id.enum';

export const CrudDataTypeEnum = { ...ActionTypeEnum, ...AdminFeatureIdEnum };
export type CrudDataTypeEnum = (ActionTypeEnum | AdminFeatureIdEnum);
